export const cardMediaStyle = (theme, mediaPosition, width) => ({
  backgroundColor: theme.tokens.ComponentCardBg,
  border: `1px solid ${theme.tokens.ComponentCardBorderColor}`,
  '.MuiPaper-rounded': {
    borderRadius: theme.tokens.ComponentCardBorderRadius
  },
  display: mediaPosition === 'left' ? 'flex' : 'block',
  flexDirection: 'column',
  height: '100%',
  width: width ? width : '100%'
});